export const setLinkLabel = (Label: string) => {
  let linkLabel = '';

  switch (Label) {
    case 'Oświetlenie': {
      return (linkLabel = `Zobacz całe ${Label.toLowerCase()}`);
    }
    case '% Sale': {
      return (linkLabel = `Zobacz ${Label.toLowerCase()}`);
    }
    case 'Kuchnia': {
      return (linkLabel = `Zobacz całą kuchnię`);
    }
    case 'Antykwariat': {
      return (linkLabel = `Zobacz cały ${Label.toLowerCase()}`);
    }
    default: {
      linkLabel = `Zobacz wszystkie ${Label.toLowerCase()}`;
    }
  }
  return linkLabel;
};
